import marketChangePrice from '@/components/market/market-change-price/market-change-price.vue';

export default {
  components: {
    marketChangePrice,
  },
  props: {
    mode: {
      type: String,
      required: true,
    },
    number: {
      type: Number,
      required: true,
    },
    average: {
      type: Number,
      required: true,
    },
    difference: {
      type: Number,
      required: true,
    },
    lastClosePrice: {},
    numberOnly: {
      type: Boolean,
      default: false,
    },
    avgPriceOnly: {
      type: Boolean,
      default: false,
    },
    theme: {
      type: String,
      default: '',
    },
    changePriceTheme: {
      type: String,
      default: '',
    },
    symbol: {
      type: String,
      default: '&cent;',
    },
  },
  computed: {
    classModifiers() {
      return {
        'market-shares-bar': true,
        [`market-shares-bar--${this.theme}`]: this.theme,
        'market-shares-bar--yes': this.mode === 'yes',
        'market-shares-bar--no': this.mode === 'no',
      };
    },
  },
  methods: {
    onClickNumber() {
      this.$emit('click');
    },
  },
};
